import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import validate from 'validate.js';
import { DialogDefaultV2, TabFormV2 } from '../../../components/v2';
import * as selectorsUsuarios from '../../../store/usuario/reducer';
import * as actionsUsuarios from '../../../store/usuario/actions';
import InformacaoBasica from './InformacaoBasica';
import InformacaoPessoalTab from './InformacaoPessoalTab';
import ArquivosTab from './ArquivosTab';

const schema = {
  nome: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  email: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  role: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const Formulario = ({
  saveUsuario,
  updateUsuario,
  selectedUsuario,
  open,
  id,
  onClose,
  findUsuarioById,
  resetPassword,
  readOnly,
  isAdmin,
  setProximaMatricula,
  userEmail,
}) => {
  const [values, setValues] = useState({ ativo: true, supervisor: false, additions: {} });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (id) findUsuarioById(id);
  }, [id, findUsuarioById]);

  useEffect(() => {
    if (id && selectedUsuario) {
      setValues(selectedUsuario);
    }
  }, [id, selectedUsuario]);

  const onSave = () => {
    const dataToValidate = { ...values, subRole: values.subRole || null };
    setValues(dataToValidate);
    const erros = validate(dataToValidate, schema);
    setErrors(erros);
    if (!erros) {
      if (dataToValidate.id) updateUsuario(dataToValidate, saveCallback);
      else saveUsuario(dataToValidate, saveCallback);
    }
  };

  const saveCallback = (success) => {
    if (success) onCloseLocal(true);
  };

  const onCloseLocal = (isSave) => {
    setErrors({});
    setValues({ ativo: true, supervisor: false, additions: {} });
    setProximaMatricula();
    onClose(isSave);
  };

  const readOnlyTabs = process.env.REACT_APP_USUARIO_READY_ONLY.split(',').includes(userEmail);
  const enableInfo = process.env.REACT_APP_USUARIO_VIEW_INFORMACOES_PESSOAIS.split(',').includes(userEmail);
  const enableDocs = process.env.REACT_APP_USUARIO_VIEW_DOCUMENTOS_CERTIFICADOS.split(',').includes(userEmail);
  const readyOnlyDocs = process.env.REACT_APP_USUARIO_VIEW_DOCUMENTOS_CERTIFICADOS_READY_ONLY.split(',').includes(userEmail);

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Usuário"
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
      readOnly={readOnly}
      headerAction={[{ onClick: () => resetPassword(id), title: 'Resetar Senha', show: !!id && isAdmin }]}
    >
      <TabFormV2
        tabPanels={[
          {
            label: 'Informações Básicas',
            element: (
              <InformacaoBasica
                id={id}
                values={values}
                setValues={setValues}
                errors={errors}
                readOnly={readOnly}
                isAdmin={isAdmin}
              />
            ),
            disabled: false,
          },
          {
            label: 'Informações Pessoais',
            element: (
              <InformacaoPessoalTab
                values={values}
                setValues={setValues}
                readOnly={readOnlyTabs}
              />
            ),
            disabled: !enableInfo,
          },
          {
            label: 'Documentos/Certificados',
            element: (
              <ArquivosTab
                values={values}
                setValues={setValues}
                readOnly={readyOnlyDocs}
              />
            ),
            disabled: !enableDocs,
          },
        ]}
      />
    </DialogDefaultV2>
  );
};

const mapStateToProps = (state) => ({
  selectedUsuario: selectorsUsuarios.getSelectedUsuario(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsUsuarios }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
